define.alias("ember-cli-string-helpers/helpers/titleize", "settings/helpers/titleize");